// Module
var code = "<div> <div class=\"form-group btn-group pull-right\"> <div class=\"btn btn-secondary game-config-btn\" ng-click=\"copy(this)\"> <i class=\"glyphicon glyphicon-copy\"></i> </div> <div class=\"btn btn-danger game-config-btn\" ng-click=\"remove(this)\"> <i class=\"glyphicon glyphicon-remove\"></i> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'ui-formly/types/copyDeleteButtons/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;